"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.uniqueId = exports.resetCounter = void 0;
// NOTE: This is module scoped to ensure that a unique ID is always assigned while the app is running.
var num;
var resetCounter = function () {
    num = 0;
};
exports.resetCounter = resetCounter;
(0, exports.resetCounter)();
var uniqueId = function (prefix) {
    var prefixString = prefix ? "".concat(prefix) : '';
    num++;
    return "".concat(prefixString).concat(num);
};
exports.uniqueId = uniqueId;
